import {PERCENTAGE_ABSOLUTE_TABS_VALUE} from '../../../utils/constants.js';

export const getPercentageAbsoluteTabs = (category) => {
    return {
        percentageAbsoluteTabDetails: {
            className: 'percentage-absolute-tabs-container',
            toggleName: 'percentage-absolute-tabs',
            category : category,
            toggle: [
                {
                    toggleLabel: 'Percentage',
                    toggleValue: PERCENTAGE_ABSOLUTE_TABS_VALUE.PERCENTAGE
                },
                {
                    toggleLabel: 'Absolute',
                    toggleValue: PERCENTAGE_ABSOLUTE_TABS_VALUE.ABSOLUTE
                }
            ]
        }
    }
};
